import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { PLANET_API_KEY } from '../config/constants'
import features from '../config/plusPlusFeatures'

const filterFeaturesByStripId = (features, stripId) => {
  return features.filter(feature => feature.properties.strip_id == stripId)
}

const filterFeaturesByFeature = (features, feature) => {
  const { acquired, item_type } = feature.properties
  const date = acquired.split('T')[0]
  return features.filter(feature => feature.properties.item_type === item_type && feature.properties.acquired.split('T')[0] === date)
}

const generateUrlFromFeature = feature => {
  const { id } = feature
  const { item_type } = feature.properties
  return `https://tiles0.planet.com/data/v1/${item_type}/${id}/{z}/{x}/{y}.png?api_key=${PLANET_API_KEY}`
}

// Redux type and action creators
const { Types, Creators } = createActions({
  planetUpdatePlusPlusRequested: ['lng', 'lat'],
  planetUpdatePlusPlusFulfilled: ['json'],
  planetUpdatePlusPlusLinkRequested: ['link'],
  planetUpdatePlusPlusLinkFulfilled: ['json'],
  planetUpdatePlusPlusFailed: [],
  planetUpdatePlusPlusUrls: ['feature'],
  reset: []
})

export const PlanetTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  fetching: false,
  urls: [],
  features: features
})

// Redux reducers
export const planetUpdateRequested = (state) => {
  return state.merge({ fetching: true })
}

export const planetUpdateFulfilled = (state, { json }) => {
  return state
  // const { features, _links } = json
  // const prevFeatures = state.features
  // if (!features || !features[0]) {
  //   return state
  // }

  // const ids = features.map(feature => feature.id)
  // const prevIds = prevFeatures.map(feature => feature.id)

  // if (ids[ids.length-1] === prevIds[prevIds.length-1]) {
  //   return state
  // }

  // return state.merge({ features })

}

export const planetUpdateLinkRequested = (state, { link }) => {
  return state.merge({ fetching: true })
}

export const planetUpdateLinkFulfilled = (state, { json }) => {
  const { features, _links } = json
  const prevFeatures = state.features
  if (!features || !features[0]) {
    return state
  }

  // const ids = features.map(feature => feature.id)
  // const prevIds = prevFeatures.map(feature => feature.id)

  // if (ids[ids.length-1] === prevIds[prevIds.length-1]) {
  //   return state
  // }

  const nextFeatures = [...prevFeatures, ...features]

  return state.merge({ feature: nextFeatures })

}

export const planetUpdateFailed = (state, { error }) => {
  console.log(error)
  return state.merge({ error })
}

export const planetUpdateUrls = (state, action) => {
  const { feature } = action
  const { features } = state

  const filteredFeatures = filterFeaturesByFeature(features, feature)
  const urls = filteredFeatures.map(feature => generateUrlFromFeature(feature))

  return state.merge({ urls })
}

export const planetReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.PLANET_UPDATE_PLUS_PLUS_REQUESTED]: planetUpdateRequested,
  [Types.PLANET_UPDATE_PLUS_PLUS_FULFILLED]: planetUpdateFulfilled,
  [Types.PLANET_UPDATE_PLUS_PLUS_LINK_REQUESTED]: planetUpdateLinkRequested,
  [Types.PLANET_UPDATE_PLUS_PLUS_LINK_FULFILLED]: planetUpdateLinkFulfilled,
  [Types.PLANET_UPDATE_PLUS_PLUS_FAILED]: planetUpdateFailed,
  [Types.PLANET_UPDATE_PLUS_PLUS_URLS]: planetUpdateUrls,
  [Types.RESET]: planetReset
})



// WEBPACK FOOTER //
// ./src/redux/planetPlusPlusRedux.js